"use client"

import { NotFoundView } from 'src/sections/error';

export default function Page() {
  return <NotFoundView />;
}
